export const PRODUCT_HEARTH_EXTENSION_RUG = {
  label: 'Hearth Extension Rug',
  value: 'PRODUCT_HEARTH_EXTENSION_RUG'
};
